import { z } from "zod";

const configSchema = z.object({
    API_BASE_URL: z.url().refine((val) => val.at(-1) === "/", {
        message: "url should end with the character '/'",
    }),
    AZURE_AD_AUTH_CLIENT_ID: z.string(),
    AZURE_AD_AUTH_AUTHORITY_URL: z.url().refine((val) => val.at(-1) === "/", {
        message: "url should end with the character '/'",
    }),
    AZURE_AD_AUTH_SCOPE: z.string(),
    AZURE_AD_AUTH_REDIRECT_URL: z.url().refine((val) => val.at(-1) === "/", {
        message: "url should end with the character '/'",
    }),
    AZURE_AD_AUTH_POST_LOGOUT_REDIRECT_URL: z.url().refine((val) => val.at(-1) === "/", {
        message: "url should end with the character '/'",
    }),
});

let config: z.infer<typeof configSchema>;
const result = configSchema.safeParse({
    API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
    AZURE_AD_AUTH_CLIENT_ID: import.meta.env.VITE_AZURE_AD_AUTH_CLIENT_ID,
    AZURE_AD_AUTH_AUTHORITY_URL: import.meta.env.VITE_AZURE_AD_AUTH_AUTHORITY_URL,
    AZURE_AD_AUTH_SCOPE: import.meta.env.VITE_AZURE_AD_AUTH_SCOPE,
    AZURE_AD_AUTH_REDIRECT_URL: import.meta.env.VITE_AZURE_AD_AUTH_REDIRECT_URL,
    AZURE_AD_AUTH_POST_LOGOUT_REDIRECT_URL: import.meta.env.VITE_AZURE_AD_AUTH_POST_LOGOUT_REDIRECT_URL,
});

class EnvironmentVariablesError extends Error {
    name = "EnvironmentVariablesError";

    constructor(errors: Record<string, string[]>) {
        const message = Object.entries(errors)
            .map(([key, errors]) => `${key}: ${errors.join(", ")}`)
            .join("\n");

        super(`\n\nErrors while validating environment variables:\n\n${message}\n\n`);
    }
}

if (result.success) {
    config = result.data;
} else {
    const errors = result.error.flatten();
    throw new EnvironmentVariablesError(errors.fieldErrors);
}

export { config };
